import {
  configureStore, ThunkAction, Action, createListenerMiddleware, PayloadAction,
} from '@reduxjs/toolkit';
import quoteReducer, { actions } from '../../features/quote/QuoteSlice';

// Create the middleware instance and methods
const addMiddleware = createListenerMiddleware();
const updateMiddleware = createListenerMiddleware();
const removeMiddleware = createListenerMiddleware();
addMiddleware.startListening({
  actionCreator: actions.addToDisplayQueue,
  effect: async (action: PayloadAction<any>, listenerApi) => {
    const targetStep = action.payload[0].step;
    if (await listenerApi.condition(
      (subAction, currentState: any) => !currentState.quote.isDrawing
              && targetStep[1] === currentState.quote.step.innerStep,
    )) {
      const state : any = listenerApi.getState();
      listenerApi.dispatch(actions.setIsDrawing(true));
      listenerApi.dispatch(actions.addToForm(state.quote.displayQueue));
      action.payload[0].fields.forEach((f: any) => listenerApi.dispatch(
        actions.removeFromDisplayQueue(f.formId),
      ));
    }
  },
});
removeMiddleware.startListening({
  actionCreator: actions.addToRemoveQueue,
  effect: async (action: any, listenerApi) => {
    const targetStep = action.payload.step;
    if (await listenerApi.condition((subAction, currentState: any) => !currentState.quote.isRemoving
                                        && targetStep[1] === currentState.quote.step.innerStep)) {
      const state : any = listenerApi.getState();
      listenerApi.dispatch(actions.setIsRemoving(true));
      listenerApi.dispatch(actions.removeFromData(action.payload.fields));
      listenerApi.dispatch(actions.addToRemoving(action.payload.fields));
      listenerApi.dispatch(actions.clearRemove());
    }
  },
});
updateMiddleware.startListening({
  actionCreator: actions.addToPreUpdateQueue,
  effect: async (action: any, listenerApi) => {
    if (await listenerApi.condition(
      (subAction, currentState: any) => !currentState.quote.isDrawing,
    )) {
      const state : any = listenerApi.getState();
      listenerApi.dispatch(actions.setIsUpdating(true));
      listenerApi.dispatch(actions.addToUpdateQueue(action.payload));
      listenerApi.dispatch(actions.clearPreUpdateQueue());
    }
  },
});

export { addMiddleware, removeMiddleware, updateMiddleware };
